/* eslint-disable @typescript-eslint/no-unused-vars */
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress,  Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import {  AutoCompletePeriodo, IVFormErrors, VForm, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { EmpFunService } from '../../../shared/services/api/rh/EmpFun/EmpFunService';
import RelatorioEmpFun from './RelatorioEmpFun';

interface IFomeTipoPgto {   
  periodo: string;   
}

const formValidationSchema: yup.ObjectSchema<IFomeTipoPgto> = yup.object().shape({
  periodo: yup.string().required(),
});              
             
export const EmprestimosFun: React.FC = () => {                 
  const { formRef, save } = useVForm();  
  const [isLoading, setIsLoading] = useState(false);     
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
          
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,    
  ) => {      
    if (reason === 'clickaway') {  
      return;
    }     
    setOpenmsg(false);
  };             
                  
  const handleSave = (dados: IFomeTipoPgto) => {                       
    formValidationSchema.       
      validate(dados, { abortEarly: false })   
      .then((dadosValidados) => {   
        setIsLoading(true);   
        EmpFunService
          .Relatorio(dadosValidados.periodo)   
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else 
            {    
              RelatorioEmpFun(result);      
            }         
          });              
      })     
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};   
        errors.inner.forEach(error => {   
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });            
  };           
     
  return (     
    <VForm ref={formRef} onSubmit={handleSave}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}       
          severity={tms}
          variant="filled"     
          sx={{ width: '100%' }}     
        >                
          {msg}                              
        </Alert>           
      </Snackbar>
      <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
        <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
        <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
          alignContent='center'>       
          <DialogTitle>Relatórios de Empréstimo Colaborador</DialogTitle>  
          <DialogContent  dividers>    
            {isLoading && (                           
              <Grid item>        
                <LinearProgress variant='indeterminate' />        
              </Grid>                            
            )}   
            <Grid container  padding={1} item direction="row" >
              <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>                       
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <AutoCompletePeriodo 
                    isExternalLoading={isLoading}  />
                </Grid> 
              </Grid>        
            </Grid>              
          </DialogContent>     
          <DialogActions>
            <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={save}>Visualizar</Button>
          </DialogActions>
        </Box>
      </Box>
    </VForm>        
  );          
};   